import { render, staticRenderFns } from "./PendingReplacementsGrid.vue?vue&type=template&id=b40d9c32&"
import script from "./PendingReplacementsGrid.vue?vue&type=script&lang=js&"
export * from "./PendingReplacementsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PendingReplacementsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports